import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../models/user';
import { MemoryStorageService } from './memory-storage.service';
import { ENachAPIData } from '../interface/interfaces';

@Injectable({
  providedIn: 'root',
})
export class MonedoService {
  baseUrl: string = '';

  public currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  private eventSource?: EventSource;

  //use HttpBackend to call http client without interceptor...
  constructor(private httpClient: HttpClient, private router: Router, private zone: NgZone) {
    this.baseUrl = environment.apiUrl;
    this.setCurrentUser(JSON.parse(MemoryStorageService.getItem('user')));
  }

  setCurrentUser(user: User) {
    this.currentUserSource.next(user);
  }

  InitiateKYC(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'menedo/initiate-kyc',
      obj
    );
  }


  CheckKYCStatus(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'menedo/kyc/status',
      obj
    );
  }

  InitiateConsent(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'menedo/initiate-consent', obj
    );
  }

  SaveCreditParameters(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'menedo/save-credit-parameters', obj
    );
  }

  getServerUpdates(loanId: string, event: string): Observable<string> {
    const url = `${this.baseUrl}menedo/${loanId}/${event}`;

    return new Observable<string>(observer => {
      this.eventSource = new EventSource(url);

      this.eventSource.onmessage = (msg) => {
        this.zone.run(() => observer.next(msg.data));
        this.eventSource?.close();
        observer.complete();
      };

      this.eventSource.onerror = (err) => {
        this.zone.run(() => observer.error(err));
        this.eventSource?.close();
      };

      return () => {
        this.eventSource?.close();
      };
    });
  }

  getWebhookStatus(loanApplicationId: string, eventType: string) {
    return this.httpClient.get<any>(`${environment.apiUrl}Menedo/webhook-status/${loanApplicationId}/${eventType}`);
  }


}
